import React, { useEffect, useState,useRef } from 'react'
import Box from "@mui/material/Box";
import MainLayout from '../components/MainLayout';
import {TextField, Button, Stack, Skeleton, Typography,Tooltip, Card, CardContent, IconButton, Table, TableCell, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { StyledTableRow, StyledTableCell } from "../Theme"
import axios from 'axios';
import Paper from '@mui/material/Paper';
import { Sparklines, SparklinesLine } from 'react-sparklines';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import CryptoTablePagination from './CryptoPricesPagination';
import { ShimmerSkeleton } from '../utils/SkimmerSkeleton';
import { captureException } from '@sentry/react';

export default function Crypto_prices() {
    const searchValueRef = useRef();
    const [coins, setCoins] = useState([]);
    const [coinsData, setCoinsData] = useState(null);
    const [totalCoins, setTotalCoins] = useState(null);
    const [sort, setSort] = useState("market_cap_desc");
    const [globalData, setGlobalData] = useState({});
    const [mktCapSort, setMktCapSort] = useState("market_cap_desc");
    const [volumeSort, setVolumeSort] = useState("volume_desc");
    const [searchValue, setSearchValue] = useState("");
    const [searchClickFlag, setSearchClickFlag] = useState(false);
    const [loading, setLoading] = useState(false)
    const [marketLoading, setMarketLoading] = useState(true)
    const [tradingLoading, setTradingLoading] = useState(true)
    const [totalMarketCap, setTotalMarketCap] = useState(0)
    const [tradingVolume, setTradingVolume] = useState(0)

    const prefixSearchUrl = 'https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=';
    const suffixSearchUrl = `&order=${sort}&per_page=100&page=1&sparkline=true&price_change_percentage=1h%2C%2024h%2C%207d`;

    const url = `https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=${sort}&per_page=25&page=1&sparkline=true&price_change_percentage=1h%2C%2024h%2C%207d`;
    
    useEffect(() => {
        getCall();
        getTotalCoins()
    }, [sort])

    const handleCoinSearchInput = value => {
        if (/^[a-zA-Z ]+$/.test(value) || value === "") {
            if (value === "" && searchClickFlag) {
                getCall();
                setSearchClickFlag(false);
            }
            searchValueRef.current.value = value;
            setSearchValue(value);
        } else {
            searchValueRef.current.value = value;
        }
    }

    const handleCoinSearchResult = async (arr) => {
        let res = '';



        arr.slice(0, arr.length - 1).map(item => {
            res += `${item.id}%2C`;
        })



        let data = `${res}${arr[arr.length - 1].id}`;

        await axios.get(`${prefixSearchUrl}${data}${suffixSearchUrl}`, {withCredentials:false}).then(res => {
            if (res.status === 200) {
                setCoins(res.data);
            }
        }).catch(error => {
            captureException(error)
        })

    }

    const searchCoins = () => {
        if (searchValueRef.current?.value?.length > 0) {
            getSearchCoins(searchValueRef.current.value);
            setSearchClickFlag(true);
        }
    }

    const getSearchCoins = async (data) => {
        await axios.get(`https://api.coingecko.com/api/v3/search?query=${data}`,{withCredentials:false}).then(res => {
            if (res.status === 200) {
                handleCoinSearchResult(res.data.coins?.slice(0, res.data.coins.length));
            }
        }).catch(error => {
            captureException(error)
        })
    }

    const formatLargeNumber = (value) => {
        const trillion = 1_000_000_000_000;
        const billion = 1_000_000_000;
      console.log("tradingLoading ",value)
        if (value >= trillion) {
          return `${(value / trillion).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})} Trillion`;
        } else if (value >= billion) {
          return `${(value / billion).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})} Billion`;
        } else {
          return value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}); 
        }
      }
console.log("marketLoading ",marketLoading)
console.log("tradingLoading ",tradingLoading)

    const getTotalCoins = () => {
        axios.get('https://api.coingecko.com/api/v3/global',{withCredentials: false}).then(res => {
            if (res.status === 200) {
                setTotalCoins(Number(res.data.data.active_cryptocurrencies) > 100 ? 100 : Number(res.data.data.active_cryptocurrencies))
                // setTotalCoins(Number(res.data.data.active_cryptocurrencies))
                setGlobalData(res.data.data);
                setLoading(false)
            }
        }).catch(error => {
            captureException(error)
        })
    }

    useEffect(() => {
        if(globalData?.total_market_cap?.usd) {
           const calculatedMarket = formatLargeNumber(globalData?.total_market_cap?.usd)
           setMarketLoading(false)
           setTotalMarketCap(calculatedMarket)
        }
    },[globalData?.total_market_cap?.usd])

    useEffect(() => {
        if(globalData?.total_volume?.usd) {
           const calculatedVolume = formatLargeNumber(globalData?.total_volume?.usd)
           setTradingLoading(false)
           setTradingVolume(calculatedVolume)
        }
    },[globalData?.total_volume?.usd])

    const getCall = async () => {
        setLoading(true)
        await axios.get(url,{withCredentials:false}).then(res => {
            if (res.status === 200) {
                setCoins(res.data);
                setLoading(false)
            }
        }).catch(error => {
            setLoading(false)
            captureException(error)
        }
        )
    }

    useEffect(() => {
        setCoinsData(coins);
      }, [coins])

      const handleVolumeSort = () => {
        if (volumeSort === 'volume_asc') {
          setSort('volume_desc');
          setVolumeSort('volume_desc');
        } else if (volumeSort === 'volume_desc') {
          setSort('volume_asc');
          setVolumeSort('volume_asc');
        }
      }
    
      const handleMktCapSort = () => {
        if (mktCapSort === "market_cap_desc") {
          setMktCapSort("market_cap_asc");
          setSort('market_cap_asc')
        } else if (mktCapSort === "market_cap_asc") {
          setMktCapSort('market_cap_desc');
          setSort('market_cap_desc');
        }
      }

    return (
    //    <Box backgroundColor='#F0F7FD' width='100%' height='auto' pl={1} overflow='hidden' sx={{ maxWidth:"1580px",}} >
        <MainLayout>
            <Box sx={{
                overflowX: { xs: 'scroll' },
                msoverflowStyle: "none",
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': {
                    width: 0,
                }

            }}>
                <Box columnGap={2} rowGap={3} sx={{
                    width: { xs: 'fit-content', sm: '100%' },
                    paddingTop: '20px',
                    display: 'flex',
                    flexWrap: { sm: 'wrap', xs: "no-wrap" },
                    justifyContent: 'space-evenly',

                }}>
                    <Card sx={{
                        minWidth: '350px',
                        height: '150px',
                        backgroundColor: 'white',
                        borderRadius: '11px',
                        borderLeft: '11px solid #E84C3D',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        flex:1,
                    }}>
                        <CardContent>
                           <Typography py={1} sx={{fontFamily:"CeraPro", fontSize:"23.99px", lineHeight:"30.15px", color:"#CACACA", fontWeight:"500"}}>
                                Market Capitalization
                            </Typography>
                            <Stack py={1} direction='row' alignItems='center'>
                                {(!loading && !marketLoading) ? <Typography variant='h2'>{totalMarketCap ? `$ ${totalMarketCap}` : ''}</Typography>
                                 : <ShimmerSkeleton variant="rectangular" width={210} height={60} />}
                            </Stack>
                        </CardContent>
                    </Card>

                    <Card sx={{
                        minWidth: '350px',
                        height: '150px',
                        backgroundColor: 'white',
                        borderRadius: '11px',
                        borderLeft: '11px solid #50AD20',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        flex:1,
                    }}>
                        <CardContent>
                        <Typography py={1} sx={{fontFamily:"CeraPro", fontSize:"23.99px", lineHeight:"30.15px", color:"#CACACA", fontWeight:"500"}}>
                                24h Trading Volume
                            </Typography>
                            <Stack py={1} direction='row' alignItems='center'>
                                {(!loading && !tradingLoading) ? <Typography variant='h2'>{tradingVolume ? `$ ${tradingVolume}` : 0}</Typography>
                                : <ShimmerSkeleton variant="rectangular" width={210} height={60} />}
                            </Stack>
                        </CardContent>
                    </Card>
                    <Card sx={{
                        minWidth: '350px',
                        height: '150px',
                        backgroundColor: 'white',
                        borderRadius: '11px',
                        borderLeft: '11px solid #93B0C8',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        flex:1,
                    }}>
                        <CardContent>
                          <Typography py={1} sx={{fontFamily:"CeraPro", fontSize:"23.99px", lineHeight:"30.15px", color:"#CACACA", fontWeight:"500"}}>
                                BTC Market Cap Dominance
                            </Typography>
                            <Stack py={1} direction='row' alignItems='center'>
                                {(!loading && globalData?.market_cap_percentage?.btc) ? <Typography variant='h2'>{`${globalData?.market_cap_percentage?.btc?.toFixed(2)} %` || ''}</Typography> 
                                : <ShimmerSkeleton variant="rectangular" width={210} height={60} />}
                            </Stack>
                        </CardContent>
                    </Card>
                </Box>
            </Box>
            <Box component='div' mt={4} sx={{ paddingLeft: { xs: '0px', sm: '0px' } }}>
                 <TableContainer component={Paper} sx={{ width: "100%", display: {xs:"none",sm:"grid"}, placeItems: 'center', }}>
                 <Box sx={{ display: 'flex', justifyContent: "flex-end", alignItems: "center", width:{xs:"100px", sm:"fit-content"}, margin: { xs: "8px 0px", md: "20px" }, gap: { xs: "8px", md: "20px" }, width: "100%", pr:{xs:"0px",sm:'40px'} }}>
                    <Typography variant='p' sx={{ fontSize: { xs: "10px", md: "15px" }, display: { xs: "none", md: "block" }, fontWeight:'500' }}>Search Crypto</Typography>
                    <Box sx={{ display: 'flex', width:{xs:"100%", sm:"fit-content"}, alignItems: "center", justifyContent: "space-between", gap: { xs: "8px", md: "25px" }, }}>
                        <TextField name="bitcoinSearch" sx={{ fontSize: { xs: "10px", md: "12px" }, width: { xs: "100%", sm:"175px", md: "250px", lg: "300px" } }} ref={searchValueRef} onChange={e => handleCoinSearchInput(e.target.value)} value={searchValue} />
                        <Button sx={{minWidth:"80px", display: 'flex', alignItems: "center", textTransform: 'none', fontSize: "14px" }} variant="contained" onClick={() => searchCoins()} startIcon={<SearchIcon style={{ height: { xs: "14px", md: "25px" }, width: { xs: "75px", md: "90px" } }} />}>
                            Search
                        </Button>
                    </Box >

                </Box>
                    <Table sx={{ width: "100%", margin: "auto" }} aria-label="simple table">
                        <TableHead>
                        <StyledTableRow>
                            <StyledTableCell>#</StyledTableCell>
                            <StyledTableCell style={{ textAlign: "left" }}>Coin</StyledTableCell>
                            <StyledTableCell >Price</StyledTableCell>
                            <StyledTableCell >1h</StyledTableCell>
                            <StyledTableCell >24h</StyledTableCell>
                            <StyledTableCell >
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                                <Typography variant='p'  >Volume</Typography>
                                <IconButton>
                                <ImportExportIcon sx={{ fontSize: "24px", color: `${(sort === "volume_asc" || sort === 'volume_desc') ? "green" : "black"}` }} onClick={() => handleVolumeSort()} />
                                </IconButton>
                            </Box>
                            </StyledTableCell>
                            <StyledTableCell >  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                            <Typography variant='p'   >Mkt Cap</Typography>
                            <IconButton>
                                <ImportExportIcon sx={{ fontSize: "24px", color: `${(sort === "market_cap_desc" || sort === 'market_cap_asc') ? "green" : "black"}` }} onClick={() => handleMktCapSort()} />
                            </IconButton>
                            </Box></StyledTableCell>
                            <StyledTableCell >Last 7 days</StyledTableCell>
                        </StyledTableRow>
                        </TableHead>
                    {!loading ? (<TableBody>
                        {coinsData?.map((row) => (
                            <TableRow
                            key={row.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 }, }}
                            >
                            <StyledTableCell component="th" scope="row" >
                                {row?.market_cap_rank}
                            </StyledTableCell>
                            <StyledTableCell   >
                            <Tooltip title={`${row?.name} ${row?.symbol?.toUpperCase()}`}>
                                <div style={{ textAlign: "left", display: 'flex', gap: "5px", alignItems: 'center' }} >

                                <img
                                    style={{ width: "20px" }}
                                    src={row?.image ? row.image : ""}
                                    alt={row?.id}
                                /><Typography noWrap sx={{maxWidth:"200px", overflow:"hidden", textOverflow:"ellipsis"}} >{row?.name} {row?.symbol?.toUpperCase()}</Typography>
                                </div></Tooltip>
                            </StyledTableCell>
                            <StyledTableCell    >{row?.current_price !== null && '$ ' + row?.current_price?.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</StyledTableCell>
                            <StyledTableCell style={{ color: `${Number(row?.price_change_percentage_1h_in_currency).toFixed(2) > 0 ? "green" : "red"}` }} >{Number(row?.price_change_percentage_1h_in_currency).toFixed(2)} %</StyledTableCell>
                            <StyledTableCell style={{ color: `${row?.price_change_percentage_24h !== null ? row?.price_change_percentage_24h.toFixed(2) > 0 ? "green" : "red" : "black"}` }}  >{row?.price_change_percentage_24h !== null ? row?.price_change_percentage_24h.toFixed(2) + " %" : "-"}</StyledTableCell>
                            <StyledTableCell    >        $ {row?.total_volume?.toLocaleString("en-US")}
                            </StyledTableCell>
                            <StyledTableCell    >$ {row?.market_cap !== null && row?.market_cap.toLocaleString("en-US")}</StyledTableCell>
                            <StyledTableCell style={{ width: "250px", display: "inline-grid", alignItems: "center" }}>

                                <Sparklines data={row?.sparkline_in_7d?.price} height={50}>
                                {/* <SparklinesLine color="teal" /> */}
                                <SparklinesLine color= {row?.sparkline_in_7d?.price[0] < row?.sparkline_in_7d?.price[row?.sparkline_in_7d?.price.length - 1] ? 'teal' : "red"} />
                                </Sparklines>
                            </StyledTableCell>
                            </TableRow>
                        ))}
                        </TableBody>) : (
                            <TableBody>
                            {Array.from(new Array(5)).map((_, rowIndex) => (
                            <TableRow key={rowIndex}>
                                {Array.from(new Array(8)).map((_, colIndex) => (
                                <TableCell key={colIndex}>
                                    <ShimmerSkeleton variant="rectangular" width="100%" height={40} />
                                </TableCell>
                                ))}
                            </TableRow>
                            ))}
                        </TableBody>
                        )}
                    </Table>
                </TableContainer>
                <TableContainer component={Paper} sx={{ width: "100%", display: {xs:"grid",sm:"none"}, placeItems: 'center', }}>
                    <Table sx={{ width: "100%", margin: "auto" }} aria-label="simple table">
                        <TableHead>
                        <StyledTableRow>
                            <StyledTableCell>#</StyledTableCell>
                            <StyledTableCell style={{ textAlign: "left" }}>Coin</StyledTableCell>
                            <StyledTableCell >Price</StyledTableCell>
                            <StyledTableCell >Graph</StyledTableCell>
                        </StyledTableRow>
                        </TableHead>
                    {!loading ? (<TableBody>
                        {coinsData?.map((row) => (
                            <TableRow
                            key={row.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 }, }}
                            >
                            <StyledTableCell component="th" scope="row" >
                                {row?.market_cap_rank}
                            </StyledTableCell>
                            <StyledTableCell   >
                                <Box sx={{ textAlign: "left", display: 'flex', gap: "5px",  }} >

                                <Box
                                    component='img'
                                    sx={{ width: "15.51px", height:"15.51px" }}
                                    src={row?.image ? row.image : ""}
                                    alt={row?.id}
                                />
                                <Box sx={{display:"flex", flexDirection:"column", gap:"5px"}}>
                                    <Typography sx={{textWrap:"wrap", fontSize:"12px", fontFamily:"CeraPro", color:"#1F3048", lineHeight:"15.08px", fontWeight:"500"}} >{row?.name}</Typography>
                                    <Typography sx={{fontSize:"10px", fontFamily:"CeraPro", color:"#8A8C8F", lineHeight:"12.57px", fontWeight:"400"}} >{row?.symbol?.toUpperCase()}</Typography>
                                </Box>
                                
                                </Box>
                            </StyledTableCell>
                            <StyledTableCell>
                            <Typography sx={{fontSize:"12px", fontFamily:"CeraPro", color:"#000000", lineHeight:"15.08px", fontWeight:"600"}} >
                                {row?.current_price !== null && row?.current_price?.toLocaleString("en-US", { style: "currency", currency: "USD" })}
                            </Typography>
                                </StyledTableCell>
                            <StyledTableCell style={{ width: "90px", display: "flex", alignItems: "center" }}>
                                <Sparklines data={row?.sparkline_in_7d?.price} height={86}>
                                <SparklinesLine color="teal" />
                                </Sparklines>
                            </StyledTableCell>
                            </TableRow>
                        ))}
                        </TableBody>) : (
                            <TableBody>
                            {Array.from(new Array(5)).map((_, rowIndex) => (
                            <TableRow key={rowIndex}>
                                {Array.from(new Array(4)).map((_, colIndex) => (
                                <TableCell key={colIndex}>
                                    <ShimmerSkeleton variant="rectangular" width="100%" height={40} />
                                </TableCell>
                                ))}
                            </TableRow>
                            ))}
                        </TableBody>
                        )}
                    </Table>
                  
                </TableContainer>

                {searchClickFlag === false && <CryptoTablePagination totalData={totalCoins} setCoins={setCoins}  sort={sort} />}
                <Typography sx={{fontFamily:"Jost,sans-serif", textAlign:"center", mt:3, fontSize:"14px", fontWeight:"500", color:"#8A8C8F"}}>All prices are displayed in USD.</Typography>
            </Box >
        </MainLayout>
)
}
